import { render } from "./custom-field-input.component.vue?vue&type=template&id=3864d0bb&ts=true"
import script from "./custom-field-input.component.vue?vue&type=script&lang=ts"
export * from "./custom-field-input.component.vue?vue&type=script&lang=ts"

import "./custom-field-input.component.vue?vue&type=style&index=0&id=3864d0bb&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__